module.exports = __webpack_public_path__ + "img/chevronDownMed.45b012d0.svg";